import React from 'react';

const EntryLarge: React.FC = (props: any) => {
    return (<div>Đang phát triển</div>)
}

export default EntryLarge;
